












import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';
import { EssayTheme } from '@/store/modules/essay/state';

export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    essayThemes: {
      type: Array as PropType<EssayTheme[]>,
      required: true,
    },
    selectedEssayTheme: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    items(): CardInfo[] {
      const items: CardInfo[] = this.essayThemes.map(essayTheme => {
        return {
          key: essayTheme.id,
          content: {
            title: essayTheme.title,
            titleSize: 'h4',
          },
        } as CardInfo;
      });
      return items;
    },
  },
  methods: {
    selectedHandler({ key }: CardInfo) {
      const selectedEssayTheme = this.essayThemes.find(essayTheme => essayTheme.id === key);
      setTimeout(() => {
        this.$emit('selected', selectedEssayTheme);
      }, 300);
    },
  },
});
